module.exports = __webpack_public_path__ + "media/images/lp_seiho/sp_main-ffcfc53b1bc40ef837473563c48ab22a.png";